import React from 'react';
import { registerPaletteElements } from 'react-page-maker';
import { leftPalettes as palettes } from './elements';
import Block from './elements/Block';
import { imagePhp } from './consts';

import store from './core/redux/store';
import axios from 'axios';
import { ajaxUri } from './consts/index';
import GKEvent from './events';
import { createNonNullExpression } from 'typescript';

export const setOverLay = (payload) => {
  if (payload && payload.settings) {
    const { background } = payload.settings;
    const opacity = background && background.overlayOpacity ? background.overlayOpacity / 100 : 0;

    if (background && background.backgroundColor && background.backgroundImage) {
      return (
        <div
          className='overlay'
          style={{
            backgroundColor: background.backgroundColor,
            opacity: opacity,
          }}
        ></div>
      );
    }
  }
};

export const validURL = (str) => {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z@\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z@\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z@\\d_]*)?$',
    'i'
  ); // fragment locator

  if (str === '') return true;

  return !!pattern.test(str);
};

export const inArray = (needle, haystack) => {
  if (haystack && Array.isArray(haystack)) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
  }
  return false;
};

export const setPalette = (tabs) => {
  let blocks = [];

  if (Array.isArray(tabs)) {
    if (tabs.length) {
      tabs.forEach((tab, tindex) => {
        blocks[tindex] = {
          id: tab.id,
          title: tab.name,
          groups: [],
        };

        if (tab.groups.length) {
          tab.groups.forEach((group, gindex) => {
            blocks[tindex].groups[gindex] = {
              title: group.name,
              items: [],
            };

            if (group.blocks.length) {
              group.blocks.forEach((block, bindex) => {
                blocks[tindex].groups[gindex].items[bindex] = {
                  id: block.id,
                  type: 'block',
                  component: Block,
                  img: block.img ? imagePhp + block.img : block.base64_img,
                  deletable: block.base64_img ? true : false,
                  path: block.path || null,
                  options: {
                    content: JSON.parse(block.json),
                  },
                };
              });
            }
          });
        }
      });
    }
  }

  palettes[0].tabs = blocks;

  let elementsOptions = [];

  const elementsToRegister = [];
  palettes.map((palette) => {
    if (palette.tabs) {
      palette.tabs.map((tab) => {
        if (tab.groups) {
          tab.groups.map((group) => {
            if (group.items) {
              group.items.map((item) => {
                elementsToRegister.push({
                  type: item.type,
                  component: item.component,
                });
                elementsOptions[item.id] = item.options;
              });
            }
          });
        }
      });
    }
  });

  registerPaletteElements(elementsToRegister);

  store.dispatch({ type: 'SET_ELEMENTOPTIONS', value: elementsOptions });
  store.dispatch({ type: 'SET_PALETTES', value: palettes });
};

export const validName = (name) => {
  const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~çèéêîôœû]/;

  if (name === '') return false;

  if (format.test(name)) return false;

  return true;
};

export const inlineElements = (elements) => {
  let inlinedElements = [];

  if (Array.isArray(elements) && elements.length > 0) {
    elements.forEach((element) => {
      if (element.initialElements && element.initialElements.length)
        inlinedElements = inlinedElements.concat(inlineElements(element.initialElements));
      else inlinedElements = inlinedElements.concat(elements);
    });
  }

  return inlinedElements;
};

export const generateStyle = (payload, target, element = '') => {
  const headings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

  let elementFont = headings.indexOf(element) > -1 ? 'heading_font' : 'body_font';
  let elementColor = headings.indexOf(element) > -1 ? 'heading_color' : 'body_color';
  let settingsIndex = 'settings';
  const appearanceSettings = (element.length && store.getState()?.rootReducer?.appearanceSettings) || {};

  let fontSize = null;
  let fontWeight = null;
  let lineHeight = null;
  let letterSpacing = null;

  if (headings.indexOf(element) > -1) {
    fontSize = appearanceSettings[element]?.size;
    fontWeight = appearanceSettings[element]?.font_weight;
    lineHeight = appearanceSettings[element]?.line_height;
    letterSpacing = appearanceSettings[element]?.letter_spacing;
  } else if (element === 'body' || element === 'paragraph') {
    fontSize = appearanceSettings['body']?.size;
  }

  const globalFontFamily = {};
  const globalStyle = {};
  if (store.getState().rootReducer.currentDevice != 'xl')
    settingsIndex = settingsIndex + '-' + store.getState().rootReducer.currentDevice;

  if (payload && (payload[settingsIndex] || payload.settings)) {
    let cssSettings = {};
    if (target === 'container') {
      const { background, border, spacing, borderRadius, opacity } = payload[settingsIndex] || payload.settings || {};
      cssSettings = {
        position: 'relative',
        backgroundColor: (background && background.backgroundColor) || (globalStyle && globalStyle?.bgColor) || null,
        backgroundImage: background && background.backgroundImage ? `url(${background.backgroundImage})` : null,
        backgroundSize: (background && background.backgroundSize) || null,
        backgroundRepeat: (background && background.backgroundRepeat) || null,
        backgroundPosition: (background && background.backgroundPosition) || null,
        backgroundAttachment: background && background.parallax ? 'fixed' : null,

        marginTop: (spacing && spacing.marginTop) || null,
        marginBottom: (spacing && spacing.marginBottom) || null,
        marginRight: (spacing && spacing.marginRight) || null,
        marginLeft: (spacing && spacing.marginLeft) || null,

        paddingTop: (spacing && spacing.paddingTop) || null,
        paddingBottom: (spacing && spacing.paddingBottom) || null,
        paddingRight: (spacing && spacing.paddingRight) || null,
        paddingLeft: (spacing && spacing.paddingLeft) || null,

        borderRadius:
          (borderRadius &&
            (borderRadius.lt ? borderRadius.lt : 0) +
              (borderRadius.unity ? borderRadius.unity : 'px') +
              ' ' +
              (borderRadius.rt ? borderRadius.rt : 0) +
              (borderRadius.unity ? borderRadius.unity : 'px') +
              ' ' +
              (borderRadius.rb ? borderRadius.rb : 0) +
              (borderRadius.unity ? borderRadius.unity : 'px') +
              ' ' +
              (borderRadius.lb ? borderRadius.lb : 0) +
              (borderRadius.unity ? borderRadius.unity : 'px')) ||
          null,
        opacity: opacity !== undefined ? opacity / 100 : null,
      };

      if (border && border.border_target) {
        cssSettings[border && border.border_target + 'Style'] = (border && border.border_style) || null;
        cssSettings[border && border.border_target + 'Color'] = (border && border.border_color) || null;
        cssSettings[border && border.border_target + 'Width'] = (border && border.border_width) || null;
      }

      if (
        payload.datas &&
        payload.datas.hiddenDevices &&
        payload.datas.hiddenDevices[store.getState().rootReducer.currentDevice]
      )
        cssSettings['opacity'] = 0.1;
    } else if (target === 'text' && element.length) {
      const { text } = payload[settingsIndex] || payload.settings;

      cssSettings = {
        color:
          (text && text.color) ||
          (appearanceSettings && appearanceSettings[element] && appearanceSettings[element].color) ||
          (appearanceSettings && appearanceSettings[elementColor] && appearanceSettings[elementColor].color) ||
          null,
        fontFamily:
          (text && text.fontFamily) ||
          (appearanceSettings && appearanceSettings[elementFont] && appearanceSettings[elementFont].fontFamily) ||
          (globalFontFamily && globalFontFamily?.fontFamily) ||
          null,
        fontWeight: (text && text.fontWeight) || fontWeight || null,
        fontSize: (text && text.fontSize) || fontSize || null,
        letterSpacing: (text && text.letterSpacing) || letterSpacing || null,
        lineHeight: (text && text.lineHeight) || lineHeight || null,
        textAlign: (text && text.textAlign) || null,
        fontStyle: (text && text.fontStyle) || null,
        textDecorationLine: (text && text.textDecorationLine) || null,
      };
    } else if (target === 'text') {
      const { text } = payload[settingsIndex] || payload.settings;
      cssSettings = {
        color: (text && text.color) || (globalStyle && globalStyle?.color) || null,
        fontFamily: (text && text.fontFamily) || (globalFontFamily && globalFontFamily?.fontFamily) || null,
        fontWeight: (text && text.fontWeight) || null,
        fontSize: (text && text.fontSize) || (globalStyle && globalStyle?.size) || null,
        letterSpacing: (text && text.letterSpacing) || null,
        lineHeight: (text && text.lineHeight) || null,
        textAlign: (text && text.textAlign) || null,
        fontStyle: (text && text.fontStyle) || null,
        textDecorationLine: (text && text.textDecorationLine) || null,
      };
    } else if (target === 'alignment') {
      const { alignment } = payload[settingsIndex] || payload.settings;

      if (alignment && alignment === 'center') {
        cssSettings.margin = 'auto';
        cssSettings.textAlign = alignment;
      } else if (alignment && alignment === 'left') {
        cssSettings.float = 'left';
        cssSettings.textAlign = alignment;
      } else if (alignment && alignment === 'right') {
        cssSettings.float = 'right';
        cssSettings.textAlign = alignment;
      }
    }
    return cssSettings;
  } else return {};
};

export const l = (string) => {
  const translations = store.getState().rootReducer.translatedStrings;

  if (translations && translations[string]) return htmlDecode(replaceAllBackSlash(translations[string]));
  else return string;
};

export const replaceAllBackSlash = (targetStr) => {
  var index = targetStr.indexOf('\\');
  while (index >= 0) {
    targetStr = targetStr.replace('\\', '');
    index = targetStr.indexOf('\\');
  }
  return targetStr;
};

export const htmlDecode = (input) => {
  var e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};

export const getLangLabel = () => {
  for (const lang of store.getState().rootReducer.fetchedLangs) {
    if (lang.value === store.getState().rootReducer.currentLang) return lang.label;
  }

  return '';
};

export const getSpecificElements = () => {
  let elements = [];

  for (const palette of palettes) {
    if (palette.id === 'elements') {
      for (const tab of palette.tabs) {
        // if( tab.id !== 'global' ){
        elements[tab.id] = [];

        for (const group of tab.groups) {
          for (const item of group.items) {
            if (!inArray(item.type, elements[tab.id])) elements[tab.id].push(item.type);
          }
        }
        // }
      }
    }
  }

  return elements;
};

export const getSpecificElementsUncategorised = () => {
  let elements = [];

  for (const palette of palettes) {
    if (palette.id === 'elements') {
      for (const tab of palette.tabs) {
        if (tab.id !== 'global') {
          for (const group of tab.groups) {
            for (const item of group.items) {
              if (!inArray(item.type, elements[tab.id])) elements.push(item.type);
            }
          }
        }
      }
    }
  }

  return elements;
};

const getSpecificPages = () => {
  let pages = [];

  for (const palette of palettes) {
    if (palette.id === 'elements') {
      for (const tab of palette.tabs) {
        if (tab.id !== 'global') {
          pages.push(tab.id);
        }
      }
    }
  }

  return pages;
};

export const inlinePayload = (payload) => {
  let elements = [];

  payload.forEach((element) => {
    elements.push(element.type);

    if (element.initialElements && element.initialElements.length > 0)
      elements = [...elements, ...inlinePayload(element.initialElements)];
  });

  return elements;
};

export const copyToPage = (pageId, layout) => {
  let layoutTypes = inlinePayload([layout]);
  const specificPages = getSpecificPages();
  const pageType = pageId.split('_')[0];

  let error = null;

  if (pageId === store.getState().rootReducer.currentPage) error = l('You cannot copy in the same page.');

  for (const layoutType of layoutTypes) {
    if (
      (inArray(pageType, specificPages) &&
        !inArray(layoutType, getSpecificElements()['global']) &&
        !inArray(layoutType, getSpecificElements()[pageType])) ||
      (!inArray(pageType, specificPages) && !inArray(layoutType, getSpecificElements()['global']))
    )
      error = l('You cannot copy this element outside.');
  }

  if (error) {
    GKEvent.notification('error', error);
  } else {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'copyElement',
        pageid: pageId,
        layout: resetId(layout, 'root'),
      },
    })
      .then((result) => {
        if (result.data.status === 'success') store.dispatch({ type: 'COPY', toCopy: null });

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {});
  }
};

export const resetId = (datas, parentId = null) => {
  const id = 'gk-' + Math.floor(Math.random() * 100000 + 1);

  let returnDatas = {};

  Object.keys(datas).forEach((key) => {
    if (key === 'id' || key === 'key') returnDatas[key] = id;
    else if (key === 'parentID') returnDatas[key] = parentId;
    else if ((datas['type'] == 'row' && key === 'initialElements') || key === 'fields') {
      let fields = [];
      if (datas[key].length > 0) {
        datas[key].forEach((field) => {
          fields.push(resetId(field, id));
        });
      }
      returnDatas[key] = fields;
    } else returnDatas[key] = datas[key];
  });

  return returnDatas;
};

export const getDashboardUrl = (target) => {
  axios({
    method: 'post',
    url: ajaxUri,
    data: {
      request: 'getDashboardUrl',
      target: target,
    },
  })
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      return '';
    });
};

export const getPayload = async (pageid) => {
  try {
    const result = await axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'get',
        target: 'payload',
        pageid: pageid,
      },
    });
    return JSON.parse(result.data);
  } catch (error) {
    return [];
  }
};

export const pagesOptions = (type) => {
  let object = [];
  for (const page of store.getState().rootReducer.fetchedPages) {
    if (page.type == type && ((page.type === 'modal_payload' && page.standard) || page.type !== 'modal_payload'))
      object.push({
        label: page.name,
        value: type + '__' + page.key,
      });
  }

  return object;
};

export const getParams = (param) => {
  var url = new URL(window.location.href);
  return url.searchParams.get(param) || null;
};

export const priceFormat = (price) => {
  return axios({
    method: 'post',
    url: ajaxUri,
    data: {
      request: 'priceFormat',
      price: price,
    },
  })
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      return '';
    });
};

export const fetchAppearanceSettings = async () => {
  const result = await axios({
    url: ajaxUri,
    method: 'post',
    data: {
      request: 'getAppearanceSettings',
    },
  });
  const setting = result?.data || {};

  let parsedSetting = {};
  for (let key in setting) {
    try {
      parsedSetting = {
        ...parsedSetting,
        [key]: JSON.parse(setting[key]),
      };
    } catch (error) {
      if (key == 'showSearch' || key == 'showLogin') {
        parsedSetting = {
          ...parsedSetting,
          [key]: setting[key] ? true : false,
        };
      } else if (typeof setting[key] === 'string' && !setting[key].includes('\\')) {
        parsedSetting = {
          ...parsedSetting,
          [key]: setting[key],
        };
      }
      if (window.location.href.includes('devgk')) {
        console.log('Some error in parsing ', key, ' value ', setting[key]);
      }
    }
  }
  store.dispatch({ type: 'SET_APPEARANCE', settings: parsedSetting });
  return parsedSetting;
};
export function isObject(val) {
  return val instanceof Object;
}

export function generateImageCss(settings) {
  const imageSpacing = settings['imageSpacing'] || {};
  const productImageCss = settings['imageCss'] || {};

  const borderRadius = (productImageCss && productImageCss.imageCornerRadius) || {};
  const boxShadow = (productImageCss && productImageCss.imageBoxShadow) || {};

  const style = {
    ...imageSpacing,
    borderRadius:
      (borderRadius &&
        (borderRadius.lt ? borderRadius.lt : 0) +
          (borderRadius.unity ? borderRadius.unity : 'px') +
          ' ' +
          (borderRadius.rt ? borderRadius.rt : 0) +
          (borderRadius.unity ? borderRadius.unity : 'px') +
          ' ' +
          (borderRadius.rb ? borderRadius.rb : 0) +
          (borderRadius.unity ? borderRadius.unity : 'px') +
          ' ' +
          (borderRadius.lb ? borderRadius.lb : 0) +
          (borderRadius.unity ? borderRadius.unity : 'px')) ||
      null,
    boxShadow: `${boxShadow?.xOffset ? boxShadow.xOffset : 0}px ${boxShadow?.yOffset ? boxShadow.yOffset : 0}px ${
      boxShadow?.blur ? boxShadow.blur : 0
    }px ${boxShadow?.spread ? boxShadow.spread : 0}px ${boxShadow?.color ? boxShadow.color : ''}`,
  };

  return style;
}
